import Component from '@glimmer/component';

import ReportsViewerBlockCtComponent from 'webapp/components/reports/viewer/block-ct';

import type ReportSlideFragment from 'webapp/models-custom/report-slide-fragment';

export interface Args {
	model: ReportSlideFragment;
}

export default class ReportsViewerFragmentBlockComponent<T extends Args> extends Component<T> {
	<template>
		<div class="fragment fragment--block">
			<ReportsViewerBlockCtComponent @model={{@model}} />
		</div>
	</template>
}
